import { render, staticRenderFns } from "./LicenseDetail.vue?vue&type=template&id=34ced932&scoped=true&"
import script from "./LicenseDetail.vue?vue&type=script&lang=ts&"
export * from "./LicenseDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ced932",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ced932')) {
      api.createRecord('34ced932', component.options)
    } else {
      api.reload('34ced932', component.options)
    }
    module.hot.accept("./LicenseDetail.vue?vue&type=template&id=34ced932&scoped=true&", function () {
      api.rerender('34ced932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/LicenseDetail.vue"
export default component.exports